export const tabEnmu = {
  dashboard: '0',
  hostes: '1',
  commission: '2',
}
